import React, {Component} from 'react'
import FrameShape from "../types/FrameShape";
import { LINE_JOIN_CONSTS, LINE_CAP_CONSTS, DEFAULT_LINE_JOIN, DEFAULT_LINE_CAP } from 'shape-edit/forms/helpers';
import { SizeType } from 'app/types/model-types';

interface Props {
    data: FrameShape
    size: SizeType
}

class DashedFrameSvg extends Component<Props> {
    render() {
        const frame = this.props.data
        const size =  this.props.size

        const strokeWidth = frame.width
        const color = frame.color
        const marginX = parseFloat(`${frame.margin_x}`)
        const marginY = parseFloat(`${frame.margin_y}`)

        const style = {strokeWidth: strokeWidth + "px", stroke: color}
        const dashArray = `${frame.dash_length} ${frame.dash_density}`

        const lineJoin = frame.line_join && LINE_JOIN_CONSTS[frame.line_join] ? LINE_JOIN_CONSTS[frame.line_join]: 'inherit'
        const strokeLinecap=frame.line_cap && LINE_CAP_CONSTS[frame.line_cap] ? LINE_CAP_CONSTS[frame.line_cap]: 'inherit'

        return (
            <g>
                <rect 
                    x={ marginX + strokeWidth/2} 
                    y={marginY + strokeWidth/2} 
                    width={size.width - 2*marginX-strokeWidth} 
                    height={size.height - 2*marginY-strokeWidth} 
                    strokeWidth={strokeWidth} 
                    fill="none" 
                    stroke={color} 
                    strokeDasharray={dashArray} 
                    strokeLinecap={strokeLinecap} 
                    strokeLinejoin={lineJoin} 
                    style={style}
                />
            </g>
        )
    }
}

export default DashedFrameSvg
